import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import Modal from '@/components/ui/modal';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';

interface NewTemplateModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (templateName: string) => void;
    saveError: string | null;
}

export default function NewTemplateModal({ isOpen, onClose, onSave, saveError }: NewTemplateModalProps) {
    const t = useTranslations();
    const inputNewTemplateName = useRef<HTMLInputElement>(null);

    const handleSave = () => {
        if (inputNewTemplateName.current) {
            onSave(inputNewTemplateName.current.value);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} ModalSize="max-w-[545px]">
            <div className="text-center text-[24px] font-[700] mb-[25px] mt-[20px]">
                {t('ScreeningRoom.modal.excludeTemplate.title')}
            </div>
            <p className="text-center mb-[36px] max-w-[360px] m-auto">
                {t.rich('ScreeningRoom.modal.excludeTemplate.text', {
                    highlight: (c: React.ReactNode) => <b>{c}</b>,
                })}
            </p>

            {saveError && <div className="text-red-500 text-center mb-4 text-sm">{saveError}</div>}

            <Input
                ref={inputNewTemplateName}
                className="w-full max-w-[300px] px-[20px] py-[22px] m-auto border-white border-1 border-[rgba(255,255,255,.80)]"
                placeholder={t('ScreeningRoom.modal.excludeTemplate.newTemplatePlaceholder')}
            />
            <div className="flex flex-col justify-center items-center">
                <Button
                    className="cursor-pointer bg-[#DD06AE] hover:bg-[#B10DCE] px-[30px] py-[25px] text-[14px] rounded-[8px] mt-[30px] mb-[20px]"
                    onClick={handleSave}
                >
                    {t('ScreeningRoom.modal.excludeTemplate.createTemplate')}
                </Button>
                <span className="cursor-pointer underline mt-[10px] mb-[11px]" onClickCapture={onClose}>
                    {t('ScreeningRoom.modal.excludeTemplate.cancelTemplate')}
                </span>
            </div>
        </Modal>
    );
}
